import { Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import KYCSuccessful from '../../assets/images/KYCSuccessful.png'
import KYCVerified from '../../assets/images/Verified.png'
import KYCVerifying from '../../assets/images/Verifying.png'
import Button from '../../components/button'
import Input from '../../components/input'
import LoadingIndicator from '../../components/loadingIndicator'
import TermsAndConditions from '../../components/termsAndConditions'
import Text from '../../components/text'
import { useAxios } from '../../core/AxiosContext'
import { useGlobal, useGlobalDispatch } from '../../core/GlobalContext'
import {
  REGISTER_DUCK,
  REGISTRATION_STATUS,
  REQUEST_STATUS,
  ROUTES,
  TOAST_DUCK,
  VALIDATION_STATUS,
} from '../../core/actions'
import { REGISTER_BACKEND_URL } from '../../core/constants'
import { errorSummary } from '../../utils/misc'
import { PAN_FORMAT } from '../../utils/validations'
import * as styles from './Register.css'

export const Register = () => {
  const {
    registerState: { reason, values, registrationStatus },
  } = useGlobal()
  const [PAN, setPAN] = useState('')
  const { registerDispatch, toastDispatch } = useGlobalDispatch()
  const { publicAxios } = useAxios()

  const [termsAndConditions, setTermsAndConditions] = useState(false)
  const [showTNC, setShowTNC] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()

  const handleBackPress = () => navigate(ROUTES.LOGIN)
  // Update Terms and Conditions in Global Store
  const handleTNC = e => {
    registerDispatch({
      type: REGISTER_DUCK.VALUES_CHANGE,
      payload: { values: { termsAndConditions: e.target.checked } },
    })
    setTermsAndConditions(e.target.checked)
  }

  const handleSubmit = async () => {
    registerDispatch({ type: REGISTER_DUCK.REGISTER_STARTED })

    // Send Welcome Mail
    publicAxios(REGISTER_BACKEND_URL).post(`/api/v1/financiers/${PAN}/notify_financier`, {
      code: PAN,
      notification_type: 'welcome_email',
    })
  }

  useEffect(() => {
    console.log('PAN', PAN)
    console.log(publicAxios)
    PAN_FORMAT.test(PAN) &&
      publicAxios(REGISTER_BACKEND_URL)
        .get(`/api/v1/financiers/${PAN}/check_financier_exists`)
        .then(response => {
          if (response?.status === 200) {
            handleBackPress()
            toastDispatch({
              type: TOAST_DUCK.SEND_TOAST,
              payload: {
                message:
                  'This is a referral only platform, kindly connect with our representative. Details at the bottom of the page',
                type: REQUEST_STATUS.FAILURE,
              },
            })
          }
        })
        .catch(err => {
          if (err?.response?.status === 409) {
            handleBackPress()
            toastDispatch({
              type: TOAST_DUCK.SEND_TOAST,
              payload: {
                message: 'We have already verified your KYC, try logging in.',
                type: REQUEST_STATUS.SUCCESS,
              },
            })
          } else {
            toastDispatch({
              type: TOAST_DUCK.SEND_TOAST,
              payload: {
                message: errorSummary(err?.response?.data) || 'Unable to validate PAN',
                type: REQUEST_STATUS.FAILURE,
              },
            })
          }
        })
  }, [PAN])

  useEffect(() => {
    let timeoutId
    let secondTimeoutId

    if (registrationStatus === REGISTRATION_STATUS.REGISTRATION_STARTED) {
      timeoutId = setTimeout(() => {
        registerDispatch({ type: REGISTER_DUCK.REGISTER_PENDING })
      }, 2500)
    }
    if (registrationStatus === REGISTRATION_STATUS.REGISTRATION_PENDING) {
      secondTimeoutId = setTimeout(() => {
        registerDispatch({ type: REGISTER_DUCK.REGISTER_SUCCESS })
      }, 1500)
    }
    return () => {
      clearTimeout(timeoutId)
      clearTimeout(secondTimeoutId)
    }
  }, [registrationStatus])

  // On load extract referralCode and update Global State
  useEffect(() => {
    window.scrollTo(0, 0)

    if (location?.state?.referralCode) {
      registerDispatch({
        type: REGISTER_DUCK.VALUES_CHANGE,
        payload: { values: { referralCode: location?.state?.referralCode } },
      })
      registerDispatch({
        type: REGISTER_DUCK.MESSAGE_CHANGE,
        payload: {
          message: {
            referralCode: {
              status: VALIDATION_STATUS.SUCCESS,
              value: 'Autofilled Referral Code shared by your friend',
            },
          },
        },
      })
    }

    // Set termsAndConditions to false initially
    registerDispatch({
      type: REGISTER_DUCK.VALUES_CHANGE,
      payload: { values: { termsAndConditions: false } },
    })
  }, [])

  // All the toasts go here
  useEffect(() => {
    let timeoutId
    if (registrationStatus === REGISTRATION_STATUS.REGISTRATION_SUCCESS) {
      toastDispatch({
        type: TOAST_DUCK.SEND_TOAST,
        payload: {
          message: 'We have verified your KYC, you can login now.',
          type: REQUEST_STATUS.SUCCESS,
        },
      })
      timeoutId = setTimeout(() => {
        handleBackPress()
      }, 2200)
    } else if (registrationStatus === REGISTRATION_STATUS.REGISTRATION_FAILURE) {
      toastDispatch({
        type: TOAST_DUCK.SEND_TOAST,
        payload: {
          message: reason ? reason : 'Your KYC matching failed, please contact your representative',
          type: REQUEST_STATUS.FAILURE,
        },
      })
    }
    return () => {
      clearTimeout(timeoutId)
    }
  }, [registrationStatus, reason])

  return (
    <div id='registerWrapper' className={styles.registerWrapper}>
      <div className={styles.register}>
        <div className={styles.header}>
          <div className={styles.headerWrapper}>
            <Text size='1.7' bold>
              Hi, there!
            </Text>
          </div>
        </div>
        <div className={styles.accountTypesWrapper}>
          <Text size='1.3' color='var(--default-text-secondary-color)' bold>
            You have been cordially invited.
          </Text>
          <Text>
            Thank you for considering our invitation to join our exclusive high-return alternative fixed income
            platform, founded by Mr. Kunal Tekwani (former co-founder of TradeCred)
          </Text>
          <Text>
            We are excited to welcome you to a community of forward-thinking users who are seeking potentially lucrative
            opportunities. We are committed to providing a transparent and supportive environment as you explore these
            high-return opportunities. Let us embark on this journey together and unlock the potential for significant
            growth in your investment portfolio!
          </Text>
          <Text>To start with this exciting journey, we request you to verify your KYC.</Text>
          <div className={styles.panContainer}>
            <Text size='1.3' color='var(--default-text-secondary-color)' bold>
              PAN — {values?.referralCode}
            </Text>
            <Input
              className={styles.panInput}
              value={PAN}
              type={'text'}
              name={'pan'}
              onChange={setPAN}
              placeholder={'Your Permanent Account Number (PAN)'}
            />
          </div>
          <div className={styles.tAndC}>
            <input type='checkbox' checked={termsAndConditions} onChange={handleTNC} name='termsAndConditions' />
            <div>
              <Text>I hereby agree to these</Text>
              <Button type='text' handleClick={() => setShowTNC(true)}>
                <Text color='#1a73e8'>Terms & Conditions </Text>
              </Button>
              <Text>and submit my PAN for KYC verification and to create an account in IncomeBazaar.</Text>
              <TermsAndConditions showTNC={showTNC} setShowTNC={setShowTNC} />
            </div>
          </div>
          <Text size='0.8' color='#808B96'>
            Your account will be created after we successfully verify your details. We will share the status of your
            account creation by email & sms.
          </Text>
          <Button
            className={styles.submitBtn}
            label={registrationStatus === REGISTRATION_STATUS.REGISTRATION_PENDING ? 'Verifying ...' : 'Proceed'}
            handleClick={handleSubmit}
            disabled={
              registrationStatus === REGISTRATION_STATUS.REGISTRATION_PENDING || !values?.termsAndConditions
            }></Button>
        </div>
      </div>
      {(registrationStatus === REGISTRATION_STATUS.REGISTRATION_PENDING ||
        registrationStatus === REGISTRATION_STATUS.REGISTRATION_STARTED ||
        registrationStatus === REGISTRATION_STATUS.REGISTRATION_SUCCESS) && (
        <Modal
          open={true}
          footer={null}
          width={600}
          centered
          closeIcon={<></>}
          bodyStyle={{
            maxHeight: '70vh',
            overflowY: 'scroll',
            padding: '2rem 1.5rem',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '1.5rem',
          }}>
          {registrationStatus === REGISTRATION_STATUS.REGISTRATION_STARTED && (
            <>
              <img src={KYCVerifying} alt='KYC Verifying' width={120} />
              <Text size='1.2' color='var(--default-text-secondary-color)'>
                Please wait while we fetch KYC for your PAN ...
              </Text>
            </>
          )}
          {registrationStatus === REGISTRATION_STATUS.REGISTRATION_PENDING && (
            <>
              <img src={KYCVerified} alt='KYC Verified' width={120} />
              <Text size='1.2' color='var(--default-text-secondary-color)'>
                Successfully fetched KYC, creating an account ...
              </Text>
            </>
          )}
          {registrationStatus === REGISTRATION_STATUS.REGISTRATION_SUCCESS && (
            <>
              <img src={KYCSuccessful} alt='Account creation successful' width={120} />
              <Text size='1.2' color='var(--default-text-secondary-color)'>
                Account creation successful
              </Text>
            </>
          )}
          <LoadingIndicator scale={1} />
        </Modal>
      )}
    </div>
  )
}
